/* eslint-disable prettier/prettier */
import { useContext } from 'react';
import { IAITranscribingNotes, AITranscribingNotesContext } from 'context';

export function useAITranscribingNotes(): IAITranscribingNotes {
  return useContext(AITranscribingNotesContext)!;
}